import { render, staticRenderFns } from "./WineryEdit.vue?vue&type=template&id=5c5d7f5b&scoped=true&"
import script from "./WineryEdit.vue?vue&type=script&lang=ts&"
export * from "./WineryEdit.vue?vue&type=script&lang=ts&"
import style0 from "./WineryEdit.vue?vue&type=style&index=0&id=5c5d7f5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5d7f5b",
  null
  
)

export default component.exports